import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/BusOneWay.png'


const _hoisted_1 = {
  id: "receive-item",
  class: "relative"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h6", null, "Biaya Pengiriman", -1)
const _hoisted_3 = { class: "select-agent flex items-start lg:mb-6 md:mb-6 mb-0 flex-wrap" }
const _hoisted_4 = { class: "p-fluid flex items-center lg:w-1/3 md:w-1/3 w-full mb-4 lg:mb-0 md:mb-0" }
const _hoisted_5 = { class: "p-field w-full" }
const _hoisted_6 = { class: "flex flex-col mb-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { for: "province" }, "Agen Berangkat Dari", -1)
const _hoisted_8 = { class: "flex " }
const _hoisted_9 = { class: "flex-grow font-bold color-primary lg:text-base md:text-sm text-sm " }
const _hoisted_10 = { class: "flex-grow-0 " }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "text-white font-bold lg:text-base md:text-sm text-sm" }, /*#__PURE__*/_toDisplayString('Dari Agen'), -1)
const _hoisted_12 = { class: "md:w-3/4 lg:w-3/4 w-full md:text-base lg:text-base text-sm" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "justify-center items-center w-1/3 lg:flex md:flex hidden" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_14 = { class: "p-fluid flex items-start flex-wrap lg:w-1/3 md:w-1/3 w-full mb-4 lg:mb-0 md:mb-0" }
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "agentId" }, "Agen Tujuan Pengiriman", -1)
const _hoisted_17 = { class: "flex mr-2 mb-2" }
const _hoisted_18 = { class: "flex-grow font-bold color-primary lg:text-base md:text-sm text-sm " }
const _hoisted_19 = { class: "flex-grow-0 " }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "text-white font-bold lg:text-base md:text-sm text-sm" }, /*#__PURE__*/_toDisplayString('Ke Agen'), -1)
const _hoisted_21 = { class: "w-full md:text-base lg:text-base text-sm" }
const _hoisted_22 = { class: "flex md:flex-row flex-col  justify-items-stretch" }
const _hoisted_23 = { class: "flex flex-1 md:flex-row flex-col  justify-items-stretch" }
const _hoisted_24 = { class: "flex-1 mr-4" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { for: "Berat" }, "Jenis Konsumen", -1)
const _hoisted_26 = { class: "flex-1 mr-4" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", { for: "KategoriId" }, "Kategori", -1)
const _hoisted_28 = { class: "flex-1 mr-4 flex flex-col" }
const _hoisted_29 = /*#__PURE__*/_createVNode("label", { for: "Berat" }, "Berat", -1)
const _hoisted_30 = { class: "p-inputgroup mt-1" }
const _hoisted_31 = { class: "p-inputgroup-addon text-sm" }
const _hoisted_32 = { class: "flex-shrink-0 mr-2 flex flex-col justify-self-end " }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", null, " .", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "pi mr-2" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M16.4873 9.49313V2.13086C16.4873 1.32314 15.8302 0.666016 15.0225 0.666016H2.13184C1.32412 0.666016 0.666992 1.32314 0.666992\r\n                  2.13086V15.0215C0.666992 15.8292 1.32412 16.4863 2.13184 16.4863H9.49408C10.2945 17.0207 11.2555 17.3327 12.2881\r\n                  17.3327C15.0702 17.3327 17.3337 15.0692 17.3337 12.2871C17.3337 11.2546 17.0217 10.2936 16.4873 9.49313ZM15.5107 2.13086V8.40788C14.636 7.67998 13.5123 7.24154 12.2881 7.24154C11.0638 7.24154 9.94014 7.67998 9.06543 8.40788V1.64258H15.0225C15.2917 1.64258 15.5107 1.86162 15.5107 2.13086ZM2.13184 1.64258H8.08887V8.08789H1.64355V2.13086C1.64355 1.86162 1.8626 1.64258 2.13184 1.64258ZM1.64355 15.0215V9.06445H8.08887V9.49313C7.55449 10.2936 7.24251 11.2546 7.24251 12.2871C7.24251 13.5114 7.68096 14.6351 8.40885 15.5098H2.13184C1.8626 15.5098 1.64355 15.2907 1.64355 15.0215ZM12.2881 16.3561C10.0444 16.3561 8.21908 14.5308 8.21908 12.2871C8.21908 10.0435 10.0444 8.2181 12.2881 8.2181C14.5317 8.2181 16.3571 10.0435 16.3571 12.2871C16.3571 14.5308 14.5317 16.3561 12.2881 16.3561Z",
      fill: "black"
    })
  ])
], -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Cek Harga ")
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "excel-price mt-4 sm:w-full  min-w-full" }, [
  /*#__PURE__*/_createVNode("div", {
    id: "spreadsheet",
    class: "excel-clone"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_DialogSearchAgen = _resolveComponent("DialogSearchAgen")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, { class: "" }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, _toDisplayString(_ctx.alamatFromAgent?.Name ?? '....'), 1),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("button", {
                      class: "flex-auto p-button p-component p-button p-button-sm rounded-lg flex items-center py-1 px-2 btn-primary",
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toogleSAgen = !_ctx.toogleSAgen))
                    }, [
                      _hoisted_11
                    ])
                  ])
                ])
              ]),
              _createVNode("p", _hoisted_12, _toDisplayString(_ctx.alamatFromAgent?.Alamat), 1)
            ])
          ]),
          _hoisted_13,
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, _toDisplayString(_ctx.alamatToAgent?.Name ?? '....'), 1),
                _createVNode("div", _hoisted_19, [
                  _createVNode("button", {
                    class: "flex-auto p-button p-component p-button p-button-sm rounded-lg flex items-center py-1 px-2 btn-primary",
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toogleSToAgen = !_ctx.toogleSToAgen))
                  }, [
                    _hoisted_20
                  ])
                ])
              ]),
              _createVNode("p", _hoisted_21, _toDisplayString(_ctx.alamatToAgent?.Alamat), 1)
            ])
          ])
        ]),
        _withDirectives(_createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.jenisKonsumen,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.jenisKonsumen = $event)),
                searchable: true,
                class: "mt-1 mb-2",
                label: "Nama",
                valueProp: "Id",
                onChange: _ctx.jenisKonsumenChange,
                options: _ctx.listJenisKonsumen,
                placeholder: "Pilih Jenis Konsumen",
                "allow-empty": false
              }, null, 8, ["modelValue", "onChange", "options"])
            ]),
            _createVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.dataKategori,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataKategori = $event)),
                searchable: true,
                class: "mt-1 mb-2",
                label: "Nama",
                valueProp: "Id",
                options: _ctx.listKategories,
                placeholder: "Pilih Kategori",
                "allow-empty": false
              }, null, 8, ["modelValue", "options"])
            ]),
            _createVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode("div", null, [
                _createVNode("div", _hoisted_30, [
                  _createVNode(_component_InputNumber, {
                    class: "input-primary",
                    min: 0,
                    modelValue: _ctx.weight,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.weight = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode("span", _hoisted_31, _toDisplayString(_ctx.getSatuan?.Kode), 1)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_32, [
            _hoisted_33,
            _createVNode("div", null, [
              _createVNode(_component_Button, {
                class: "p-button btn-primary mt-1 mb-2 rounded-lg ",
                onClick: _ctx.cekHargaAct
              }, {
                default: _withCtx(() => [
                  _hoisted_34,
                  _hoisted_35
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.showCekHargaForm]
        ]),
        _hoisted_36
      ]),
      _: 1
    }),
    (_ctx.toogleSAgen)
      ? (_openBlock(), _createBlock(_component_DialogSearchAgen, {
          key: 0,
          title: 'Pilih Asal Agen',
          isShowDialog: _ctx.toogleSAgen,
          onHideDialog: _cache[6] || (_cache[6] = ()=>_ctx.toogleSAgen=false),
          onSendOutData: _cache[7] || (_cache[7] = (v) => {_ctx.getSearchAgenData(v, 'origin-agent')})
        }, null, 8, ["isShowDialog"]))
      : _createCommentVNode("", true),
    (_ctx.toogleSToAgen)
      ? (_openBlock(), _createBlock(_component_DialogSearchAgen, {
          key: 1,
          title: 'Pilih Tujuan Agen',
          isShowDialog: _ctx.toogleSToAgen,
          onHideDialog: _cache[8] || (_cache[8] = ()=>_ctx.toogleSToAgen=false),
          onSendOutData: _cache[9] || (_cache[9] = (v) => {_ctx.getSearchAgenData(v, 'destination-agent')})
        }, null, 8, ["isShowDialog"]))
      : _createCommentVNode("", true)
  ]))
}